export default function CheckItem({ checked, label, onToggle, testId }) {
  return (
    <div
      role="checkbox"
      tabIndex={0}
      aria-checked={checked}
      className="ks-check-row"
      data-checked={checked}
      data-testid={testId}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onToggle();
        }
      }}
    >
      <span className="ks-check-box" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="ks-check-label">{label}</span>
    </div>
  );
}
